import React, { FC, useEffect } from 'react';

import {
    PieChartOutlined,
    LineChartOutlined,
    DotChartOutlined,
    AreaChartOutlined,
    BarChartOutlined,
    QuestionCircleOutlined,
    FunnelPlotOutlined,
    DashboardOutlined
} from '@ant-design/icons';
import { Button, Switch, Tooltip } from 'antd';

import { useActions } from '../../../shared/common/hooks/useActions';
import { useTypedSelector } from '../../../shared/common/hooks/useTypedSelector';


const ButtonsType = () => {
    const { isCompare } = useTypedSelector((state) => state.meta);
    const { chartType, isAxesVisible } = useTypedSelector((state) => state.chart);
    const { setChartType, setMetaChartFetching, setMetaCompareChartFetching, setAxesVisibleValue } = useActions();

    const changeType = (type: string) => {

        setChartType(type);
        if (isCompare) {
            setTimeout(() => setMetaCompareChartFetching({ value: true }), 50);
        } else {
            setMetaChartFetching({ value: true });
        }
    };

    useEffect(() => {
        if (isCompare) {
            if (chartType === 'bar') {
                changeType('bar');
            } else if (chartType !== 'line') {
                changeType('line');
            }
        }
    }, [ isCompare ]);


    const chartTypes = [
        { type: 'pie', icon: <PieChartOutlined />, title: 'Круговая', disabledOnCompare: true },
        { type: 'line', icon: <LineChartOutlined />, title: 'Линии', disabledOnCompare: false },
        { type: 'area', icon: <AreaChartOutlined />, title: 'Области', disabledOnCompare: true },
        { type: 'bar', icon: <BarChartOutlined />, title: 'Колонки', disabledOnCompare: false },
        { type: 'bubble', icon: <DotChartOutlined />, title: 'Пузырьковая', disabledOnCompare: true },
        { type: 'tunnel', icon: <FunnelPlotOutlined />, title: 'Тунельная', disabledOnCompare: true },
        { type: 'speedometer', icon: <DashboardOutlined />, title: 'Спидометр', disabledOnCompare: true },
    ];

    const isAxesSupported = chartType === 'line' || chartType === 'area';

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div style={{
                display: 'flex',
                gap: '2px',
                padding: '4px',
                background: '#f0f0f0',
                borderRadius: '8px',
            }}>
                {chartTypes.map((item) => (
                    <Tooltip key={item.type} title={item.title}>
                        <Button
                            onClick={() => changeType(item.type)}
                            icon={item.icon}
                            type="text"
                            disabled={isCompare && item.disabledOnCompare}
                            className={`display-type-btn ${chartType === item.type ? 'selected' : ''}`}
                        />
                    </Tooltip>
                ))}
            </div>
            {isAxesSupported && (
                <span style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 6,
                    color: '#595959',
                    fontSize: 14,
                    marginLeft: 4,
                }}>
                    <span>Ось Y</span>
                    <Switch
                        checked={isAxesVisible}
                        onChange={(checked) => setAxesVisibleValue(checked)}
                        size="small"
                    />
                </span>
            )}
        </div>
    );
};

export default ButtonsType;